// extracted by mini-css-extract-plugin
export default {"tableHover":"commandes_tableHover__anMel","searchbar":"commandes_searchbar__W0JOq"};